import { atom } from "jotai";
import { atomFamily, atomWithStorage, createJSONStorage } from "jotai/utils";
import type { DraftLineItem, ReturnDraft, ReturnMode, ShippingAddress } from "../types";

export const draftReturnAtomFamily = atomFamily(
  (orderId: string) =>
    atomWithStorage<ReturnDraft | null>(
      `return-draft-${orderId}`,
      null,
      createJSONStorage(() => sessionStorage),
    ),
  (a, b) => a === b,
);

export const draftLineItemsAtomFamily = atomFamily((orderId: string) =>
  atom<DraftLineItem[]>((get) => {
    const draft = get(draftReturnAtomFamily(orderId));
    return draft?.lineItems ?? [];
  }),
);

export const draftReturnModeAtomFamily = atomFamily((orderId: string) =>
  atom<ReturnMode | null>((get) => {
    const draft = get(draftReturnAtomFamily(orderId));
    return draft?.returnMode ?? null;
  }),
);

export const draftAddressAtomFamily = atomFamily((orderId: string) =>
  atom<ShippingAddress | null>((get) => {
    const draft = get(draftReturnAtomFamily(orderId));
    return draft?.address ?? null;
  }),
);
